
<div id="profile" class="page-layout simple tabbed">

    <!-- HEADER -->
    <div
        class="header p-24 accent"
        fxLayout="column"
        fxLayoutAlign="center center"
        fxLayout.gt-sm="column"
        fxLayoutAlign.gt-sm="space-between start"
        [ngClass]="{ 'not-graphic': equity.length == 0 }"
    >

        <div
            class="user-info"
            fxLayout="row"
            fxLayoutAlign="center center"
            fxLayout.gt-sm="row"
            fxLayoutAlign.gt-sm="start center"
            *ngIf="cliente"
        >
            <button
                mat-icon-button
                class="mr-0 mr-sm-16"
                [routerLink]="'/clientes/consulta'"
            >
                <mat-icon>arrow_back</mat-icon>
            </button>

            <div
                class="name"
                [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}"
                (click)="changeInfoClient()"
                style="cursor:  pointer;"
            >
                {{ (cliente.numero_xp != null ? cliente.numero_xp : 'SEM CONTA') +' - ' +cliente.nome }}
            </div>
        </div>

        <div
            fxLayout="row"
            fxLayoutAlign="start center"
            [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}"
            *ngIf="equity.length > 0"
        >
            <div
                fxLayout="row"
                fxLayoutAlign="start center"
            >
                <div
                    class="chartEquity"
                    *ngIf="equity != undefined && equity != null"
                >
                    <!-- todo: verificar -->
                    <ngx-charts-advanced-pie-chart
                        [view]="view"
                        label="Patrimônio Total"
                        [scheme]="colorScheme"
                        [results]="equity"
                        [gradient]="gradient"
                        (select)="onSelect($event)"
                        [valueFormatting]="realValueFormat"
                        [percentageFormatting]="percentValueFormat"
                    >
                    </ngx-charts-advanced-pie-chart> 
                </div>
            </div>
        </div>

        <div
            class="updateDate"
            *ngIf="equity.length > 0"
        >

            <button
                mat-icon-button
                (click)="initAplication()"
            >
                <mat-icon>refresh</mat-icon>
            </button>

            <mat-form-field fxFlex="100" floatLabel="always">
                <mat-label>Atualizado em: </mat-label>
                
                 <input
                    matInput
                    [matDatepicker]="picker"
                    [matDatepickerFilter]="diasDisponiveis"
                    [formControl]="data_agenda"
                    [disabled]="isDisabledDate"
                    readonly
                    name="data_agendamento"
                    placeholder="Escolha uma Data"
                    (dateChange)="changeDateAvailable($event)"
                    readonly
                >
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            
            </mat-form-field>
        </div>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div
        class="content"
        *ngIf="!isHabilityRendaVariavelClient && !isHabilityExtractClient"
    >

        <div
            id="about"
            class="p-24"
            fxLayout="row wrap"
        >

            <div
                class="about-content"
                fxLayout="column"
                fxFlex="100"
                fxFlex.gt-sm="50"
                fxFlex.gt-md="65">

                <!-- INFORMAÇÕES DO CLIENTE -->
                <div class="profile-box info-box general" fxLayout="column">

                    <mat-tab-group>
                        <mat-tab
                            class="accent title"
                            label="Informações do Cliente"
                        >
                            <ng-template matTabContent>
                                <div class="content">
                                    <app-posicao-consolidada></app-posicao-consolidada>
                                </div>
                            </ng-template>
                        </mat-tab>

                        <mat-tab
                            class="accent title"
                            label="Dados Financeiros"
                        >
                            <ng-template matTabContent>
                               <cadastro-dados-financeiro [client]="cliente">
                               </cadastro-dados-financeiro>
                            </ng-template>
                        </mat-tab>

                        <mat-tab
                            class="accent title"
                            label="Dados Familiares"
                        >
                            <ng-template matTabContent>
                                <app-lista-estrutura-familiar [cliente_id]="cliente.id">
                                </app-lista-estrutura-familiar>
                            </ng-template>
                        </mat-tab>

                        <mat-tab
                            class="accent title"
                            label="Oportunidades"
                        >
                            <ng-template matTabContent>
                                <lista-oportunidade-cliente [cliente_id]="cliente.id">
                                </lista-oportunidade-cliente>
                            </ng-template>
                        </mat-tab>

                        <mat-tab>
                            <ng-template mat-tab-label>
                                <button 
                                    mat-raised-button
                                    style="cursor:  pointer;"
                                    class="fuse-white"
                                    (click)="editFichaCadastral()"
                                >
                                    Ficha Cadastral
                                </button>
                            </ng-template>
                        </mat-tab>
                    </mat-tab-group>
                </div>
                <!-- INFORMAÇÕES DO CLIENTE -->


                <!-- INVESTIMENTOS -->
                <div
                    class="profile-box info-box work"
                    fxLayout="column"
                    *ngIf="equity.length > 0"
                >

                    <header class="accent">
                        <div class="title">Investimentos</div>
                    </header>

                    <div>
                        <cliente-investimentos
                            [client]="cliente"
                            [clientEquity]="equity"
                            [dataOperacao]="data_agenda.value"
                        ></cliente-investimentos>
                    </div>

                </div>
                <!-- FIM INVESTIMENTOS -->

                <!-- GESTAO DE RELACIONAMENTO -->
                <!-- <div class="profile-box info-box contact" fxLayout="column">

                    <header class="accent">
                        <div class="title">Gestão de Relacionamento</div>
                    </header>

                    <div class="content"></div>
                </div> -->
                <!-- FIM GESTAO DE RELACIONAMENTO -->

                <!-- VARIAÇÃO PATRIMONIAL -->
                <evolucao-patrimonial [client]="cliente">
                </evolucao-patrimonial>
                <!-- FIM VARIAÇÃO PATRIMONIAL -->

               


            </div>

            <!-- EXTRATO -->
            <div
                class="about-sidebar"
                fxLayout="column"
                fxFlex="100"
                fxFlex.gt-sm="50"
                fxFlex.gt-md="35"
            >

                <div
                    class="profile-box friends"
                    fxLayout="column"
                >
                    <historico-movimentacao
                        [client_id]="data"
                        [isComplete]="false"
                        [range]="'week'"
                        (habilityExtractFullClient)="changeExtractClient($event)"
                    >
                    </historico-movimentacao>

                </div>


            </div>
            <!-- FIM EXTRATO -->

             <!-- CONTENT RELACIONAMENTO -->
            <div                
                fxLayout="column"
                fxFlex="100"
                fxFlex.gt-sm="100"
                fxFlex.gt-md="100" 
            >
                <div id="about" fxLayout="row wrap">
                    <div
                        class="profile-box info-box general"
                        fxLayout="column"
                        fxFlex="100"
                    >
                        <app-gestao-relacionamento-cliente [cliente_id]="data"></app-gestao-relacionamento-cliente>
                    </div>
                </div>
            </div>
            <!-- / CONTENT RELACIONAMENTO -->
        </div>


    </div>
    <!-- / CONTENT -->

    <!-- CONTENT RENDA VARIAVEL -->
    <div
        class="content"
        *ngIf="isHabilityRendaVariavelClient"
    >
        <div id="about" class="p-24" fxLayout="row wrap">
            <div
                class="profile-box info-box general"
                fxLayout="column"
                fxFlex="100"
            >

                <cliente-renda-variavel-perfil
                    [client]="cliente"
                >
                </cliente-renda-variavel-perfil>

            </div>
        </div>
    </div>
    <!-- / CONTENT RENDA VARIAVEL -->

    <!-- CONTENT EXTRATO -->
     <div
        class="content"
        *ngIf="isHabilityExtractClient"
    >
        <div id="about" class="p-24" fxLayout="row wrap">
            <div
                class="profile-box info-box general"
                fxLayout="column"
                fxFlex="100"
            >

                <historico-movimentacao
                    [client_id]="data"
                    [isComplete]="true"
                >
                </historico-movimentacao>

            </div>
        </div>
    </div>
    <!-- / CONTENT EXTRATO -->

   

</div>
